import React from 'react';

/* ──────────────────────────────────────────────────────────────────────────
   ChartTooltip — shared glow-chart tooltip using the Card recipe (§3 Tooltip):
   near-black card, hairline ring, muted label, gold-leaning value, with a small
   glowing swatch per series. `getColor(entry)` resolves the swatch colour, since
   a series' stroke/fill is a url(#gradient) ref that can't be used as a CSS colour.
   ────────────────────────────────────────────────────────────────────────── */
const ChartTooltip = ({ active, payload, label, valueFormatter, getColor }) => {
  if (!active || !payload || !payload.length) return null;
  const fmt = valueFormatter || ((v) => v);

  return (
    <div className="rounded-arc-ctl bg-arc-card ring-1 ring-arc-line shadow-arc px-3 py-2">
      {label != null && label !== '' && (
        <div className="text-xs text-arc-ink-3 mb-1">{label}</div>
      )}
      <div className="space-y-0.5">
        {payload.map((p, i) => {
          const color = (getColor && getColor(p)) || p.color || 'var(--arc-accent)';
          return (
            <div key={i} className="flex items-center gap-2 text-sm">
              <span
                className="inline-block w-2 h-2 rounded-full shrink-0"
                style={{ background: color, boxShadow: `0 0 6px ${color}` }}
              />
              {p.name != null && <span className="text-arc-ink-3">{p.name}</span>}
              <span className="ml-auto pl-3 tnum font-semibold text-arc-accent-ink">
                {fmt(p.value)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChartTooltip;
